<script setup lang="ts">
/**
 * 「还在吗？」弹层。
 *
 * 上一位顾客走掉、屏幕停在别人的购物车上，是触屏机最典型的现场事故。
 * 所以超时要提醒、再超时才清空；顾客碰一下「我还要点」就继续。
 */
defineProps<{ seconds: number }>();
const emit = defineEmits<{ (e: 'stay'): void; (e: 'reset'): void }>();
</script>

<template>
  <div class="overlay">
    <div class="dialog idle">
      <div class="idle__icon">👋</div>
      <div class="dialog__title">还要继续点餐吗？</div>
      <div class="idle__text">
        为了保护您的点餐内容，<b class="idle__num">{{ seconds }}</b> 秒后会自动清空，回到首页。
      </div>
      <div class="dialog__footer idle__footer">
        <button class="btn btn--ghost" @click="emit('reset')">不用了</button>
        <button class="btn btn--primary btn--xl" @click="emit('stay')">继续点餐</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.idle {
  width: min(640px, 100%);
  text-align: center;
  align-items: center;
}

.idle__icon {
  font-size: 60px;
  line-height: 1;
}

.idle__text {
  font-size: 21px;
  line-height: 1.6;
  color: var(--muted);
}

.idle__num {
  color: var(--brand);
  font-size: 28px;
}

.idle__footer {
  width: 100%;
  justify-content: center;
}
</style>
